export enum EmployeeOrderSaleReportScope {
    Orders = "orders",
    Sales = "sales",
    OrdersAndSales = "orders-and-sales",
}
